const organizationTagCategories = ['staff-title']

module.exports = organizationTagCategories
